import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import FirestoreService from '../assets/js/firestore_instance';
import Preloader from './Preloader';
import Purchase from './Purchase';
import { motion } from 'framer-motion';

const StagedGroups = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const db = FirestoreService.getFirestore();
  const [loading, setLoading] = useState(true);
  const [stagedGroups, setStagedGroups] = useState([]);
  const [organization, setOrganization] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const authCheck = onAuthStateChanged(auth, (user) => {
      if (user) {
        const docRef = doc(db, "admin_users", user.uid);
        getDoc(docRef)
          .then(async (doc) => {
            if (doc.exists()) {
              await getOrganization(doc.data().organizationId[0]);
              await getStagedGroups(doc);
            }
          })
          .catch((error) => {
            console.error("Error getting document:", error);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        navigate('/sign-in');
      }
    });

    return () => authCheck();
  }, [auth, db, navigate]);

    const getOrganization = async (orgId) => {
      try {
        const orgRef = doc(db, 'organizations', orgId);
        const orgDoc = await getDoc(orgRef);
        
        if (orgDoc.exists()) {
          setOrganization(orgDoc.data());
        } else {
          console.error("Organization not found");
        }
      } catch (error) {
        console.error("Error fetching organization:", error);
      }
    };
        
  
    const getStagedGroups = async (doc) => {
      try {
        const orgId = doc.data().organizationId[0];
        const groupsRef = collection(db, 'staged_groups');
        const q = query(groupsRef, where('org_id', '==', orgId));
        const snapshot = await getDocs(q);
        var groupsList = snapshot.docs.map(doc => doc.data());
        //filter out archived groups
        groupsList = groupsList.filter(group => group.archivedAt == "" || group.archivedAt === null);
        setStagedGroups(groupsList);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };

    const handleImageClick = (image) => {
      setSelectedImage(image);
    };
  
    const handleClose = () => {
      setSelectedImage(null);
    };
  
    const handleOverlayClick = (e) => {
      if (e.target === e.currentTarget) {
        handleClose();
      }
    };

  if (loading) {
    return <Preloader />;
  }


  return (
    <div className='min-h-screen min-w-screen p-8 dashboard-element-bg'>
      <div className='dashboard-main-color rounded-3xl w-full p-8 mt-20'>
        <div className="flex flex-col">
          <div className="border-b border-gray-700 pb-4 mb-6">
            <h1 className="text-3xl font-bold text-white">
              {organization?.organizationName}
            </h1>
          </div>
          <Purchase />
          <div className="mt-6 dashboard-element-bg rounded-lg p-8">
          <motion.div
              className="flex justify-center mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              <motion.a
                href="https://buy.stripe.com/9AQ7vm9IH0NfaYw5kl" //prod
                // href="https://buy.stripe.com/test_3cs3fWel94225jyfYZ" //dev
                className={`justify-center items-center flex flex-col integrate text-white py-2 px-4 rounded-full shimmer`}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Become a Member Today
              </motion.a>
            </motion.div>
            <motion.div 
              className="flex justify-center items-center w-1/2 mx-auto text-center my-7 text-white"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
            >
              When you become a member, all of your groups will be integrated to your JoltChat dashboard
              where you can activate and manage them at your choosing.
              </motion.div>  
            <h2 className="text-2xl text-white font-semibold mb-4">Your JoltChat Groups Preview</h2>
            {stagedGroups.length > 0 ? (
              <ul>
                {stagedGroups.map((group, index) => (
                  <li key={index} className="mb-4 flex items-center p-4 dashboard-on-element rounded-lg shadow-md">
                    <img
                      src={group.grpAvatar}
                      alt={group.name}
                      className="w-32 h-20 rounded-lg mr-4 cursor-pointer"
                      onClick={() => handleImageClick(group.grpAvatar)}
                    />
                    <span className="text-lg text-white font-medium flex-grow">{group.title}</span>
                    
                  </li>
                ))}
              </ul>
            ) : (
              <p>No groups.</p>
            )}
          </div>
        </div>
      </div>
      {selectedImage && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50"
          onClick={handleOverlayClick}
        >
          <div className="relative">
            <img src={selectedImage} alt="Selected" className="max-w-full max-h-full rounded-lg" />
            <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={handleClose}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
export default StagedGroups;